<template>
    <div class="dashboard">

        <g-card
            class="margem card-resumo pendentes"
            titulo="Pedidos Pendentes"
            iconeEsquerda="IconTotalGanho.svg"
            corTitulo="white"
            corCabecalho="#df7801"
            fontSizeTitulo="16px"
        >

            <template #cabecalho>
                    <div class="card-pedidos">
                        <img class="icon-cards" src="@/assets/imgs/IconTotalGanho.svg" />
                    <div class="titulo-pedidos-cabecalho">Pedidos Pendentes</div>
                </div>
            </template>
            <div class = "card-pendente card-resumo-conteudo">
                <div class = "card-conteudo-pendente card-conteudo">{{totalPedidosPendentes}}</div>
                <img @click="pushPedidoPendente()" class="icone" src="../../assets/imgs/icone_pedidos_pendentes.svg" />
            </div>
        </g-card>

        <g-card
            class="margem card-resumo andamento"
            titulo="Pedidos em Andamento"
            iconeEsquerda="IconTotalGanho.svg"
            corTitulo="white"
            corCabecalho="#2E9E24"
            fontSizeTitulo="14px"
        >
            <template #cabecalho>
                    <div class="card-pedidos">
                        <img class="icon-cards" src="@/assets/imgs/IconTotalGanho.svg" />
                    <div class="titulo-pedidos-andamento-cabecalho">Pedidos Concluídos</div>
                </div>
            </template>
            <div class="card-andamento card-resumo-conteudo">
                <div class = "card-conteudo-andamento card-conteudo">{{totalPedidosConcluidos}}</div>
                <img @click="pushPedidoEmAndamento()" class="icone" src="../../assets/imgs/icone_pedidos_concluidos.svg" />
            </div>
        </g-card>

        <g-card
            class="margem card-resumo concluidos"
            titulo="Pedidos Concluidos"
            iconeEsquerda="IconTotalGanho.svg"
            corTitulo="white"
            corCabecalho="#24799E"
            fontSizeTitulo="14px"
        >   
            <template #cabecalho>
                    <div class="card-pedidos">
                        <img class="icon-cards" src="@/assets/imgs/IconTotalGanho.svg" />
                    <div class="titulo-pedidos-cabecalho">Orçamentos Concluídos</div>
                </div>
            </template>
            <div class = "card-concluido card-resumo-conteudo">
                <div class = "card-conteudo-concluido card-conteudo">{{totalOrcamentosConcluidos}}</div>
                <img @click="pushConsultaOrcamento()" class="icone" src="../../assets/imgs/icon_seta_azul.svg" />
            </div>
        </g-card>

        <g-card
            class="margem card-resumo cancelados"
            titulo="Pedidos Cancelados"
            iconeEsquerda="IconTotalGanho.svg"
            corTitulo="white"
            corCabecalho="#F6BD00"
            fontSizeTitulo="14px"
        >   
            <template #cabecalho>
                    <div class="card-pedidos">
                        <img class="icon-cards" src="@/assets/imgs/IconTotalGanho.svg" />
                    <div class="titulo-pedidos-cabecalho">Orçamentos Pendentes</div>
                </div>
            </template>
            <div class="card-cancelado card-resumo-conteudo">
                <div class = "card-conteudo-cancelado card-conteudo">{{totalOrcamentosPendentes}}</div>
                <img @click="pushOrcamentoPendente()" class="icone" src="../../assets/imgs/icon_expandir_amarelo.svg"  />
            </div>
        </g-card>

        <!-- <g-card
            class="margem card-grande motivos-perda"
            titulo="Ag motivo de perda"
            expansivel
            iconeEsquerda="icone_ag_motivos_perdas.svg"
            iconeDireita="icone_filtro.svg"
            fontSizeTitulo="14px"
        >
        </g-card>

        <g-card
            class="margem card-grande pendencias"
            titulo="Pendências"
            iconeEsquerda="icone_ag_motivos_perdas.svg"
            iconeDireita="icone_filtro.svg"
            fontSizeTitulo="14px"
        >
        </g-card>

        <g-card
            class="margem card-grande orcamentos-digitacao"
            titulo="Orçamentos digitação"
            iconeEsquerda="icone_ag_motivos_perdas.svg"
            iconeDireita="icone_filtro.svg"
            fontSizeTitulo="14px"
        >
        </g-card> -->

        <!-- <g-card
            class="margem card-grande pedidos-pendencias"
            titulo="Pedidos com pendências"
            iconeEsquerda="icone_ag_motivos_perdas.svg"
            iconeDireita="icone_filtro.svg"
            fontSizeTitulo="14px"
        >
        </g-card> -->

    </div>
</template>

<script>

import Dashboard from './Dashboard.js'
export default Dashboard

</script>

<style scoped>

.margem{
    margin: 15px auto;
}

.dashboard {
    display: grid;
    width: 100%;

    padding: 10px;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: 0.4fr 1fr 1fr;
    gap: 30px 20px;
    grid-template-areas:
        /* "items-menu items-menu items-menu items-menu items-menu items-menu items-menu items-menu items-menu items-menu items-menu items-menu" */
        "pendentes pendentes pendentes andamento andamento andamento concluidos concluidos concluidos cancelados cancelados cancelados"
        "motivos-perda motivos-perda motivos-perda motivos-perda motivos-perda motivos-perda pendencias pendencias pendencias pendencias pendencias pendencias"
        "orcamentos-digitacao orcamentos-digitacao orcamentos-digitacao orcamentos-digitacao orcamentos-digitacao orcamentos-digitacao pedidos-pendencias pedidos-pendencias pedidos-pendencias pedidos-pendencias pedidos-pendencias pedidos-pendencias"
        ;
}

.menu-dashboard { grid-area: items-menu; }

.pendentes { grid-area: pendentes; }

.andamento { grid-area: andamento; }

.concluidos { 
    grid-area: concluidos; 
}

.cancelados { 
    grid-area: cancelados;
    }

.motivos-perda {
    
    grid-area: motivos-perda;
    height: auto;
}

.pendencias { grid-area: pendencias; }

.orcamentos-digitacao { grid-area: orcamentos-digitacao; }

.pedidos-pendencias { grid-area: pedidos-pendencias; }

.menu-dashboard{
    margin: 0 auto;
    width: 100%;
    height: 7vh;
    min-height: 0;
}
.menu-dashboard .g-card-conteudo {
    padding: 0;
}


.items-menu-dashboard{
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
}

.card-resumo{
    width: 100%;
}

.card-grande{
    width: 100%;
    height: 100%;
}

.card-conteudo{
    font: normal normal medium Montserrat;
    justify-content: center;
    display: flex;
    align-items: center;
    text-align: center;
    justify-self: center;
}

.card-conteudo-pendente{
    color: #DF7801;
}

.card-conteudo-andamento{
    color: #2E9E24
}

.card-conteudo-concluido{
    color: #24799E;
    
}

.card-conteudo-cancelado{
    color: #F6BD00;
}
.card-resumo-conteudo{
    display: flex;
    justify-content: space-between;
    margin: auto;
}

@media (min-width:310px) {
    .dashboard{
        display: block;
    }

    .card-resumo{
        height: 110px;
    }

    .card-conteudo{
        font-size: 27px;
    }

    .icone{
        grid-area:"icone";
        width: 28px;
        cursor: pointer;
        margin-right:10px ;
    }

    .menu-dashboard{
        display: none;
    }

        .card-pedidos{
        display: flex;
        margin: -10px;
        align-items: center;
    }
    .icon-cards{
        width: 32px;
        height: 32px;
    }

    .cabecalho{
        display: flex;
    }
    .titulo-pedidos-cabecalho{
        padding-left:15px;
        color:white;
    }
    .titulo-pedidos-andamento-cabecalho{
        padding-left:15px;
        color:#FFFFFF
    }

}
@media (min-width:368px) {
    .card-resumo{
        height: 15vh;
    }

    .card-conteudo{
        font-size: 35px;
    }

    .icone{
        grid-area:"icone";
        width: 32px
    }

        .card-pedidos{
        display: flex;
        margin: -10px;
        align-items: center;
    }
    .icon-cards{
        width: 32px;
        height: 32px;
    }

    .cabecalho{
        display: flex;
    }
    .titulo-pedidos-cabecalho{
        padding-left:15px;
        color:white;
    }
    .titulo-pedidos-andamento-cabecalho{
        padding-left:15px;
        color:#FFFFFF
    }

}
@media (min-width:600px) {
    .card-resumo{
        grid-area:"icone";
        height: 14vh;
    }

    :deep(.card-titulo){
        font-size: 20px;
    }

        .card-pedidos{
        display: flex;
        margin: -10px;
        align-items: center;
    }
    .icon-cards{
        width: 32px;
        height: 32px;
    }

    .cabecalho{
        display: flex;
    }
    .titulo-pedidos-cabecalho{
        padding-left:15px;
        color:white;
    }
    .titulo-pedidos-andamento-cabecalho{
        padding-left:15px;
        color:#FFFFFF
    }


}
@media (min-width:801px) {
    .card-resumo{
        height: 10vh;
    }

    .icone{
        grid-area:"icone";
        width: 36px;
    }

        .card-pedidos{
        display: flex;
        align-items: center;
    }
    .icon-cards{
        width: 32px;
        height: 32px;
    }

    .cabecalho{
        display: flex;
    }
    .titulo-pedidos-cabecalho{
        padding-left:15px;
        color:white;
    }
    .titulo-pedidos-andamento-cabecalho{
        padding-left:15px;
        color:#FFFFFF
    }

    .card-resumo-conteudo{
    display: flex;
    justify-content: space-between;
    margin: auto;
    margin-top: -10px;
    }

}
@media (min-width:1025px) {
    .dashboard{
        display: grid;
    }
    .card-resumo{
        height: 100%;
    }
    .menu-dashboard{
        display: block;
    }
    :deep(.card-titulo){
        font-size: 18px;
    } 

    .card-pedidos{
        display: flex;
        margin: -10px;
        align-items: center;
    }
    .icon-cards{
        width: 32px;
        height: 32px;
    }

    .cabecalho{
        display: flex;
    }
    .titulo-pedidos-cabecalho{
        padding-left: 10px;
        color:white;
    }
    .titulo-pedidos-andamento-cabecalho{
        padding-left: 10px;
        color:#FFFFFF
    }

    .card-resumo-conteudo{
        display: grid;
        grid-template-columns: 15% 85%;
        grid-template-rows: auto;
        grid-template-areas: "card-conteudo icone";
        margin: auto;
        justify-items: end;
        align-items: end;
        margin-top: 15px;
        margin-inline-end: -15px;
    }

    .card-conteudo{
        grid-area:"card-conteudo";
    }

    .icone{
        grid-area:"icone";
        width: 28px;
    }

    


}
@media (min-width:1281px) {

}

</style>
